import { getDictionaries } from "@/utils/helpers";
import axios from "@/utils/axios";
export default {
    namespaced: true,
    state: () => ({
        dictDataList: {},
        // 岗位激励状态
        postIncentiveStatusDict: [],
        // 岗位激励点数
        postIncentiveArchitectureDict: [],
        // 合同模板类型
        laborContract: [],
        // 合同状态
        laborContractType: [],
        // 合同主体
        laborContractCompany: [],
        // 协议类型
        laborContractOther: [],
        // 额度控制
        holiday_quota_control: [],
        // 假期规则-单位
        holiday_rule_unit: [],
        fileState: [],
        // 盘点活动确认阶段
        inventoryConfirmEvaluatorStatus: [],
        // 盘点场景
        inventoryScene: [],
        // 潜力类型
        senseOfWorth: [],
        // 指标类型
        pIndexType: [],
        // 指标单位
        indexValueUnit: [],
        // 达标场景
        toTargetScene: [],
        // 不发放赏金原因
        notSendMoneyReward: []
    }),
    getters: {
        postIncentiveStatusDict: state => state.postIncentiveStatusDict,
        postIncentiveArchitectureDict: state => state.postIncentiveArchitectureDict,
        laborContract: state => state.laborContract,
        laborContractType: state => state.laborContractType,
        laborContractCompany: state => state.laborContractCompany,
        laborContractOther: state => state.laborContractOther,
        holiday_quota_control: state => state.holiday_quota_control,
        holiday_rule_unit: state => state.holiday_rule_unit,
        fileState: state => state.fileState,
        getterDictData: state => (name) => state[name],
        getterDictDataList: state => state.dictDataList || [],
    },
    mutations: {
        SET_DICT_DATA_LIST(state, { dictData, dictCode }) {
            state.dictDataList[dictCode] = dictData
        },
        SET_DICT_DATA (state, { dictData, dictCode }) {
            state[dictCode] = dictData.map((item) => {
                return {
                    label: item.name,
                    code: item.code
                }
            })
        },
        SET_DICT_DATA_COMMON_METHOD (state, { res, stateKey }) {
            state[stateKey] = res || []
        },
        SET_POST_INCENTIVE_STATUS (state, data) {
            state.postIncentiveStatusDict = data
        },
        SET_POST_INCENTIVE_ARCHITECTURE (state, data) {
            state.postIncentiveArchitectureDict = data
        },
        SET_LABOR_CONTRACT (state, data) {
            state.laborContract = data.map((item) => {
                return {
                    label: item.name,
                    code: item.code
                }
            })
        },
        SET_LABOR_CONTRACT_TYPE (state, data) {
            state.laborContractType = data.map((item) => {
                return {
                    label: item.name,
                    code: item.code
                }
            })
        },
        SET_LABOR_CONTRACT_COMPANY (state, data) {
            state.laborContractCompany = data.map((item) => {
                return {
                    label: item.companyName,
                    code: item.companyId
                }
            })
        },
        SET_LABOR_CONTRACT_ORTHER (state, data) {
            state.laborContractOther = data.map((item) => {
                return {
                    label: item.name,
                    code: item.code
                }
            })
        },
        SET_FILE_STATE (state, data) {
            state.fileState = data.map((item) => {
                return {
                    label: item.name,
                    code: item.code
                }
            })
        }
    },
    actions: {
        getDictData ({ commit, state }, dictCode) {
            if (state[dictCode] && state[dictCode].length > 0) return
            getDictionaries(dictCode).then((res) => {
                commit('SET_DICT_DATA', { dictData: res, dictCode })
            });
        },
        getDictDataCommonMethod ({ commit, state }, { stateKey, dictCode }) {
            if (state[stateKey] && state[stateKey].length) return
            getDictionaries(dictCode).then((res) => {
                commit('SET_DICT_DATA_COMMON_METHOD', { res, stateKey })
            });
        },
        getColValCommentList ({ commit, state }, { stateKey, classStr }) {
            if (state[stateKey] && state[stateKey].length) return
            axios
                .post(
                    `/${process.env.VUE_APP_PROXY_DING_OA}/dictionary/getColValCommentList?classStr=${classStr}`
                )
                .then(({ data }) => {
                    commit('SET_DICT_DATA_COMMON_METHOD', { res: data, stateKey })
                });
        },
        getPostIncentiveStatusDict ({ commit, state }) {
            if (state.postIncentiveStatusDict && state.postIncentiveStatusDict.length) return
            getDictionaries("PostIncentiveStatus").then((res) => {
                commit('SET_POST_INCENTIVE_STATUS', res)
            });
        },
        getPostIncentiveArchitectureDict ({ commit, state }) {
            if (state.postIncentiveArchitectureDict && state.postIncentiveArchitectureDict.length) return
            getDictionaries("POSTINCENTIVE_ARCHITECTURE").then((res) => {
                commit('SET_POST_INCENTIVE_ARCHITECTURE', res)
            });
        },
        // 获取合同模板类型字典
        getLaborContractDict ({ commit, state }) {
            if (state.laborContract && state.laborContract.length) return
            getDictionaries("LABOR_CONTRACT").then((res) => {
                commit('SET_LABOR_CONTRACT', res)
            });
        },
        // 获取合同状态字典
        getContractTypeDict ({ commit, state }) {
            if (state.laborContractType && state.laborContractType.length) return
            getDictionaries("LABOR_CONTRACT_TYPE").then((res) => {
                commit('SET_LABOR_CONTRACT_TYPE', res)
            });
        },
        // 获取合同主体字典
        getLaborContractCompanyDict ({ commit, state }) {
            if (state.laborContractCompany && state.laborContractCompany.length) return;
            axios.post(`/${process.env.VUE_APP_PROXY_DING_OA}/company/getHrCompanyName`).then(({ data }) => {
                commit('SET_LABOR_CONTRACT_COMPANY', data)
            })
        },
        // 获取协议类型字典
        getLaborContractOtherDict ({ commit, state }) {
            if (state.laborContractOther && state.laborContractOther.length) return
            getDictionaries("LABOR_CONTRACT_ORTHER").then((res) => {
                commit('SET_LABOR_CONTRACT_ORTHER', res)
            })
        },
        // 获取文件状态字典
        getFileStateDict ({ commit, state }) {
            if (state.fileState && state.fileState.length) return
            getDictionaries("CERTIFY_STATUS").then((res) => {
                commit('SET_FILE_STATE', res)
            })
        },
    }
}